import React from 'react';
import { useTranslation } from 'react-i18next';
import ButtonCommon from '../../Button';
import styles from '../Profile.module.css';

/**
 * Reusable component for edit mode action buttons (Discard/Save)
 */
const ProfileEditActions = ({ onDiscard, onSave, saveText, saveDisabled }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.actionsRight}>
      <ButtonCommon
        color="primary"
        className={`${styles.btnSized} ${styles.btnMarginRight}`}
        onClick={onDiscard}
        text={t('discard')}
      />
      <ButtonCommon
        color="primary"
        className={styles.btnSized}
        onClick={onSave}
        text={saveText || t('Save')}
        disabled={saveDisabled}
      />
    </div>
  );
};

export default ProfileEditActions;
